import PortfolioMobile from 'components/PortfolioMobile';
import Portfolio from '../../components/Portfolio/index';
import { DataEyou } from '../../components/Portfolio/data';

export default function Eyou() {
  return (
    <>
      <div className="d-none d-lg-block">
        <Portfolio data={DataEyou} />
      </div>
      <div className="d-block d-lg-none">
        <PortfolioMobile data={DataEyou} />
      </div>
    </>
  );
}
